import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
// import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
// import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import { IconGrain, IconMathFunction, IconZoomCheck } from '@tabler/icons-react';

const items = [
  {
    icon: <SettingsSuggestRoundedIcon />,
    title: 'Highly performant',
    description:
      'Our API was built with performance in mind, averaging <200ms response times across endpoints.',
  },
  {
    icon: <IconGrain />,
    title: 'Largest Short Answer Trivia Service in the World',
    description:
      'Trivia Owl maintains the largest verified data store of short answer trivia questions.',
  },
  {
    icon: <ThumbUpAltRoundedIcon />,
    title: 'Developer friendly',
    description:
      'Our data is highly filterable and comes with client SDKs for easily verifying short answer questions.',
  },
  {
    icon: <IconMathFunction />,
    title: 'Cutting edge answer evaluation',
    description:
      'We provide a proprietary freeform answer checking endpoint which leverages multiple text analysis algorithms and machine learning.',
  },
  {
    icon: <SupportAgentRoundedIcon />,
    title: 'Reliable support',
    description:
      'You can count on us to address issues, respond to feature requests, and improve the quality of our data over time.',
  },
  {
    icon: <IconZoomCheck />,
    title: 'Precision in every detail',
    description:
      'Enjoy a meticulously crafted trivia experience, constantly being improved over time.',
  },
];

export default function Highlights() {
  return (
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        // color: 'white',
        // bgcolor: 'grey.900',
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Typography component="h2" variant="h4" gutterBottom>
            Highlights
          </Typography>
          <Typography variant="body1" sx={{ 
            // color: 'grey.400'
             }}>
            Explore why our product stands out: performance, quantity,
            quality, and innovation. Enjoy
            precision in every detail.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {items.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Stack
                direction="column"
                component={Card}
                spacing={1}
                useFlexGap
                sx={{
                  color: 'inherit',
                  p: 3,
                  height: '100%',
                  borderColor: 'hsla(220, 25%, 25%, 0.3)',
                  // backgroundColor: 'grey.800',
                }}
              >
                <Box sx={{ opacity: '50%' }}>{item.icon}</Box>
                <div>
                  <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'grey.700' }}>
                    {item.description}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
